// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  fydlApi: {
    apiKey: 'AIzaSyBrtVfXHIYCopP1JGNqLh1ZBzlU7oN74VI',
    url: 'https://api.fydl-app.com:3000',
    // url: 'http://127.0.0.1:3000',
    // url: 'http://dev-api.fydl-app.com:3000'
  },
  stripe: {
    // pub_key: 'pk_test_jTRZpmBEa7WZrmoS89gsNI0R',
    pub_key: 'pk_live_G6b8LCOSof8zCeANdvwvQZsG'
  },
  wheelGame: {
    urlPrefix: 'https://fydl-app.com',
    // urlPrefix: 'http://fydl-app.loc',
    // urlPrefix: 'https://showcase.fydl-app.com',
    earnRewardQrCodePrefix: '#WHEEL_RESULT_ID#',
  }
};

//
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
